import { schools, getSchoolColor } from './data';

interface AreaReassignModalProps {
  areaId: string;
  currentSchool: string;
  schoolStatus: Record<string, boolean>;
  onSelect: (schoolName: string) => void;
  onClose: () => void;
}

export function AreaReassignModal({
  areaId,
  currentSchool,
  schoolStatus,
  onSelect,
  onClose,
}: AreaReassignModalProps) {
  const openSchools = schools.filter((s) => schoolStatus[s.name]);

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-2xl w-80 max-w-[90vw] overflow-hidden">
        <div className="bg-davis-navy px-4 py-3">
          <h3 className="text-white font-semibold text-sm">
            Reassign Area {areaId}
          </h3>
          <p className="text-white/70 text-xs mt-0.5">
            Currently: {currentSchool}
          </p>
        </div>
        <div className="p-2">
          {openSchools.map((school) => {
            const color = getSchoolColor(school.name);
            const isCurrent = school.name === currentSchool;
            return (
              <button
                key={school.name}
                onClick={() => onSelect(school.name)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors text-left ${
                  isCurrent
                    ? 'bg-davis-navy/10'
                    : 'hover:bg-gray-50'
                }`}
              >
                <div
                  className="w-4 h-4 rounded-full flex-shrink-0"
                  style={{ backgroundColor: color }}
                />
                <span className="text-sm font-medium text-davis-charcoal">
                  {school.name}
                </span>
                {isCurrent && (
                  <span className="ml-auto text-xs text-davis-navy font-medium">
                    Current
                  </span>
                )}
              </button>
            );
          })}
        </div>
        <div className="border-t px-4 py-3">
          <button
            onClick={onClose}
            className="w-full px-3 py-2 text-xs font-medium text-davis-slate bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
